import React from 'react';
import styles from '../RateView.module.css';
import FilterLabel from './FilterLabel';

class FilterBooleanField extends React.Component {

	constructor(props) {
		super(props);
		let rateView = props.rateView;
		
		let filterValue = null;
		if( rateView.rvContext && rateView.rvContext.filtersInitData ) {
			for(let f of rateView.rvContext.filtersInitData) {
				if( f.predicateId == props.filter.predicateId ) {
					filterValue = f.value;
					break;
				}
			}
		} else {
			let initialValue = props.filter.initialValue;
			if( initialValue == null )
				initialValue = '';
			filterValue = (initialValue == 'true');
		}
		this.state = {
			checked: filterValue
		}
	}
	componentDidMount() {
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}
	
	clearFilter() {
		this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		this.setState({checked: false});
	}	
	handleCheckBoxChange = e => {
		this.props.rateView.clearData();
		const checked = e.target.checked;
		this.setValue( checked );
	}
	setValue = (checked) => {
		this.setState({checked: checked});
		
		let q = this.props.rateView.query;
		let indexFilter = -1;
		let predicate;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			if( checked ) {
				predicate = {
					predicateId: this.props.filter.predicateId,
					conditionId: this.props.filter.conditionId,
					value: '1'
				};
				q.listPredicate.push( predicate );
			}
		} else {
			if( checked ) {
				q.listPredicate[indexFilter].value = '1';
			} else {
				q.listPredicate.splice( indexFilter, 1 );
			}
		}
	}	

	fetchProfile = () => {
		if( this.state.checked )
			return {filterId: this.props.filter.predicateId, value: true};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.setValue( profile.value );
	}
	
	render() {
		let filter = this.props.filter;
		return (
			<div className={styles.divFilter}>
				<div className={styles.divFilterInput}>
					<input type="checkbox" onChange={this.handleCheckBoxChange} checked={this.state.checked}/>
					<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				</div>
			</div>
		);
	}	
}

export default FilterBooleanField;